<template>
	<v-sheet flat class="ma-4"> 
		<v-row>
			<v-col>
				<v-text-field v-model="contract.name" label="Name"></v-text-field>
				<v-textarea v-model="contract.description" label="Description"></v-textarea>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<AddManyTable name="Terms to include in requests" single="blurb" :items="blurbs" :columns="[{name: ' ', type: 'text', value: 'text'}]"></AddManyTable>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6" md="6">
				<v-menu
				ref="menu1"
				v-model="menu1"
				:close-on-content-click="false"
				transition="scale-transition"
				offset-y
				min-width="290px"
				>
				<template v-slot:activator="{ on }">
					<v-text-field
					v-model="contract.startDate"
					label="Start Date"
					prepend-icon="mdi-calendar"
					readonly
					v-on="on"
					></v-text-field>
				</template>
				<v-date-picker v-model="contract.startDate" no-title scrollable>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
					<v-btn text color="primary" @click="$refs.menu1.save(date)">OK</v-btn>
				</v-date-picker>
				</v-menu>
			</v-col>
			<v-col cols="12" sm="6" md="6">
				<v-menu
				ref="menu2"
				v-model="menu2"
				:close-on-content-click="false"
				transition="scale-transition"
				offset-y
				min-width="290px"
				>
					<template v-slot:activator="{ on }">
						<v-text-field
						v-model="contract.endDate"
						label="End Date"
						prepend-icon="mdi-calendar"
						readonly
						v-on="on"
						></v-text-field>
					</template>
					<v-date-picker v-model="contract.endDate" no-title scrollable>
						<v-spacer></v-spacer>
						<v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
						<v-btn text color="primary" @click="$refs.menu2.save(date)">OK</v-btn>
					</v-date-picker>
				</v-menu>
			</v-col>
		</v-row>	
		<v-row>
			<v-col>
				<v-tabs right color="primary" v-model="tab">
					<v-tab href="#additionalFieldsTab">
						Fields to include in requests
					</v-tab>
					<v-tab href="#costsTab">
						Standard Costs
					</v-tab>
					<v-tab-item value="additionalFieldsTab">
						<AddManyTable :importProps="{ defaults: {}, initialFields: ['name', 'description', 'type', 'options']}"  name="" single="field" :items="contract.additionalFields" :columns="additionalFieldColumns"></AddManyTable>
					</v-tab-item>
					<v-tab-item value="costsTab">
						<AddManyTable :importProps="{ defaults: {}, initialFields: ['name', 'description', 'cpu']}" single="cost" :items="contract.costs" :columns="costColumns"></AddManyTable>
					</v-tab-item>
				</v-tabs>
			</v-col>
		</v-row> 
			<v-divider></v-divider>
			<StorageList :allowUpload="true" :folder="contractPath" :folders="[]"></StorageList>	
		<v-row>
			<v-col>
				<p class="text-right"> <v-btn color="green" dark @click="saveContract">Save Contract</v-btn></p>
			</v-col>
		</v-row>
	</v-sheet>
</template>

<script>
	import Vue from "vue";
	import AddManyTable from "../tools/AddManyTable.vue";
	import {formatDateTime} from "../../assets/utilities.js"
	import StorageList from "../../components/tools/StorageList.vue"
	export default{
		name: "ContractForm", 
		props: {
			contract: { type: Object}
		},
		components: {
			AddManyTable: AddManyTable,
			StorageList: StorageList
		},
		data: () => {
			return {
				tab: "additionalFieldsTab",
				blurbs: [],
				costColumns: [
					{name: "Name", value: "name", type: "text", rounded: true, filled: true, dense: true },
					{name: "Description", value: "description", type: "text", rounded: true, filled: true, dense: true },
					{name: "CPU", value: "cpu", type: "text", rounded: true, filled: true, dense: true },
				],
				additionalFieldColumns: [
					{name: "Name", value: "name", type: "text", rounded: true, filled: true, dense: true },
					{name: "Description", value: "description", type: "text", rounded: true, filled: true, dense: true },
					{name: "Type", value: "type", type: "select", options: ['text', 'select'], rounded: true, filled: true, dense: true },
					{name: "Options", value: "options", type: "text", rounded: true, filled: true, dense: true },
				]
			}
		},
		computed: {
			contractPath(){
				return "/organisations/" + this.contract.organisation + "/contracts/" + this.contract.id
			}
		},
		methods: {
			saveContract(){
				const self = this;
				let contract = {...self.contract }
				if( contract.startDate ){
					contract.startDate = formatDateTime(contract.startDate, false )
				}
				if( contract.endDate ){
					contract.endDate = formatDateTime(contract.endDate, false )
				}
				if( self.blurbs ){
					contract.blurbs = self.blurbs.map( b => {
						return b.text
					} );
				}
				self.$store.dispatch( "updateDoc", {
					doc: "contracts/" + contract.id, 
					action: "update", 
					data: contract
				}).then( () => {
					self.$emit("saved")
				})
				
			}
		},
		watch: {
			contract: {
				immediate: true, 
				handler() {

					if(!this.contract.additionalFields){
						this.contract.additionalFields = [];
					}
					if(!this.contract.contacts){
						this.contract.contacts = [];
					}
					if(!this.contract.costs){
						this.contract.costs = [];
					}
					if(this.contract.blurbs){
						this.blurbs = this.contract.blurbs.map( b => { return {text: b} })
					}
					if( this.contract.startDate ){
						this.contract.startDate = Vue.moment(this.contract.startDate.toDate()).format("YYYY-MM-DD")
					}
					if( this.contract.endDate ){
						this.contract.endDate = Vue.moment(this.contract.endDate.toDate()).format("YYYY-MM-DD")
					}
				}
			}
		}

	}
</script>